import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { makeSelectTextDirection } from 'containers/Main/selectors';

const styles = makeStyles(theme => ({
  resourceName: {
    ...theme.typography.h6,
    fontSize: '0.875rem',
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: 51 /* Fallback for non-webkit */,
    marginBottom: 6,
    direction: ({ textDirection }) => textDirection,
  },
  longName: {
    '-webkit-line-clamp': '4',
    maxHeight: 68,
    marginBottom: 0,
  },
  personalizedTitle: {
    marginBottom: '5px',
    marginTop: '12px',
    textTransform: 'uppercase',
    color: '#01619B',
    fontSize: '1.0rem',
    fontWeight: 700,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '3',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: 60,
    fontFamily: 'MadaBold',
  },
  link: {
    textDecoration: 'none',
  },
}));
function Title({ title, type, personalizedCard, titleClassName }) {
  const textDirection = useSelector(makeSelectTextDirection());
  const classes = styles({ textDirection });

  return (
    <Grid item xs={12}>
      <Typography
        align="left"
        color="textPrimary"
        className={_classNames(titleClassName, {
          [classes.resourceName]: true,
          [classes.longName]: type === 'news',
          [classes.personalizedTitle]: personalizedCard,
        })}
      >
        {title}
      </Typography>
    </Grid>
  );
}

Title.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  titleClassName: PropTypes.string,
};

export default Title;
